<template>
  <div class="option-toggle">
    <div class="descriptor">
      <h5 v-if="getT">{{getT.static.summary[0].install_label}}</h5>
      <p>{{ translatedName }}</p>
    </div>
    <div class="toggle-wrap">
      <button 
        v-for="(choice) in currPool.options.install.choices"
        v-bind:key="choice.id"
        class="toggle"
        :class="{ 'active': $store.state.optionSelections.install.value === choice.id }"
        v-on:click="setActive(choice.id)">
        <img :src="getIconUrl(choice)" :alt="choice.id">
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'OptionInstallType',
  methods: {
    setActive(value) {
      // Commit active change to Vuex
      this.$store.dispatch('updateOptionSelections', { name: 'install', value: value });
      // analytics
      this.$emit('installTypeClick', value)
    },
    getIconUrl(choice) {
      var icons = require.context('@/assets/icons/');
      return icons('./' + choice.icon);
    }
  },
  computed: {
    ...mapGetters(['getT', 'currPool']),
    selectedChoice() {
      return this.currPool.options.install.choices.find(d=>d.id===this.$store.state.optionSelections.install.value)
    },
    translatedName() {
      return this.selectedChoice ? this.selectedChoice.displayName : ''
    },
  }
}
</script>
<style scoped lang="scss">
.option-toggle {
  padding: .5rem .7rem .5rem 1rem;
  min-height: 4.5em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid $deep-slate;
  .descriptor {
    h5 {
      min-width: 5em;
      color: white;
    }
    p {
      color: $muted-white;
      font-family: 'Europa Bold';
      font-size: .8rem;
      letter-spacing: 1px;
    }
  }
  .toggle-wrap {
    max-width: 20em;
    padding-left: .5rem;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
    button.toggle {
      width: 50px;
      height: 50px;
      padding: 0;
      margin: .2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'Europa Regular', sans-serif;
      background-color: transparent;
      border: none;
      cursor: default;
      &.active {
        background-color: $teal;
      }
      @media #{$desktop} {
        pointer: cursor;
        transition-duration: 200ms;
        &:not(.active):hover {
          background-color: lighten($navy, 4%);;
        }
      }
    }
  }
}
</style>
